import clsx from 'clsx';

import type { FooterProps } from './Footer.types';
import classes from './Footer.module.css';

export const Footer = (props: FooterProps) => {
    const { className } = props;

    return (
        <div className={clsx(classes.root, className)}>
            <div className={classes.content}>
                {props.children}
            </div>
        </div>
    );
};

Footer.displayName = 'Footer';
